// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard {
    padding: 2rem;
    margin-left: 250px;
    margin-top: 70px;
}

.dashboard-header {
    margin-bottom: 2rem;
}

.dashboard-header h1 {
    margin: 0;
    font-size: 2rem;
    color: #333;
}

.text-muted {
    color: #666;
    margin-top: 0.5rem;
}

.metrics-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);  /* Show exactly 4 columns */
    gap: 1.5rem;
    margin-bottom: 2rem;
}

.metric-card {
    background: white;
    border-radius: 12px;
    padding: 1.5rem;
    display: flex;
    align-items: flex-start;
    gap: 1rem;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    transition: transform 0.2s, box-shadow 0.2s;
    cursor: pointer;
}

.metric-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.metric-icon {
    width: 48px;
    height: 48px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.5rem;
}

.metric-icon.users {
    background-color: #e3f2fd;
    color: #1976d2;
}

.metric-icon.gmv {
    background-color: #e8f5e9;
    color: #2e7d32;
}

.metric-icon.revenue {
    background-color: #fce4ec;
    color: #c2185b;
}

.metric-icon.active-transactions {
    background-color: #e8eaf6;
    color: #3f51b5;
}

.metric-content {
    flex: 1 1;
}

.metric-content h3 {
    margin: 0;
    font-size: 0.9rem;
    color: #666;
    margin-bottom: 0.5rem;
}

.metric-value {
    font-size: 1.5rem;
    font-weight: 600;
    color: #333;
    margin-bottom: 0.5rem;
}

.metric-growth {
    font-size: 0.9rem;
    display: flex;
    align-items: center;
    gap: 0.25rem;
}

.metric-growth.positive {
    color: #2e7d32;
}

.metric-growth.negative {
    color: #d32f2f;
}

.metric-label {
    font-size: 0.9rem;
    color: #666;
    display: flex;
    align-items: center;
    gap: 0.25rem;
}

/* Modal Styles */
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
}

.modal-content {
    background: white;
    border-radius: 12px;
    padding: 2rem;
    width: 90%;
    max-width: 1000px;
    max-height: 90vh;
    overflow-y: auto;
}

.modal-content h2 {
    margin: 0 0 1.5rem 0;
    color: #333;
}

.metrics-controls {
    display: flex;
    flex-wrap: wrap;
    gap: 1.5rem;
    margin-bottom: 2rem;
    padding: 1rem;
    background: #f8f9fa;
    border-radius: 8px;
}

.timeframe-selector,
.date-range {
    display: flex;
    align-items: center;
    gap: 1rem;
}

.date-range {
    flex: 1 1;
    justify-content: flex-end;
}

.date-input {
    display: flex;
    align-items: center;
    gap: 0.5rem;
}

.metrics-controls label {
    color: #666;
    font-size: 0.9rem;
}

.metrics-controls select,
.metrics-controls input {
    padding: 0.5rem;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 0.9rem;
}

.chart-container {
    background: white;
    padding: 1rem;
    border-radius: 8px;
    margin-bottom: 2rem;
    height: 400px;
}

.modal-actions {
    display: flex;
    justify-content: flex-end;
    gap: 1rem;
}

.btn {
    padding: 0.75rem 1.5rem;
    border-radius: 6px;
    border: none;
    cursor: pointer;
    font-size: 0.9rem;
    font-weight: 500;
    transition: background-color 0.2s;
}

.btn.primary {
    background-color: #4a90e2;
    color: white;
}

.btn.primary:hover {
    background-color: #357abd;
}

/* Add responsive grid for smaller screens */
@media (max-width: 1200px) {
    .metrics-grid {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (max-width: 768px) {
    .metrics-grid {
        grid-template-columns: 1fr;
    }

    .metrics-controls {
        flex-direction: column;
        gap: 1rem;
    }

    .date-range {
        flex-direction: column;
        align-items: stretch;
    }

    .modal-content {
        width: 95%;
        padding: 1rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,WAAW;AACf;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,qCAAqC,GAAG,2BAA2B;IACnE,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,yCAAyC;IACzC,2CAA2C;IAC3C,eAAe;AACnB;;AAEA;IACI,2BAA2B;IAC3B,wCAAwC;AAC5C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,YAAY;AAChB;;AAEA,iBAAiB;AACjB;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oCAAoC;IACpC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,UAAU;IACV,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,eAAe;IACf,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;;IAEI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,SAAO;IACP,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;;IAEI,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,SAAS;AACb;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,4CAA4C;AAC5C;IACI;QACI,qCAAqC;IACzC;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,sBAAsB;QACtB,oBAAoB;IACxB;;IAEA;QACI,UAAU;QACV,aAAa;IACjB;AACJ","sourcesContent":[".dashboard {\n    padding: 2rem;\n    margin-left: 250px;\n    margin-top: 70px;\n}\n\n.dashboard-header {\n    margin-bottom: 2rem;\n}\n\n.dashboard-header h1 {\n    margin: 0;\n    font-size: 2rem;\n    color: #333;\n}\n\n.text-muted {\n    color: #666;\n    margin-top: 0.5rem;\n}\n\n.metrics-grid {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);  /* Show exactly 4 columns */\n    gap: 1.5rem;\n    margin-bottom: 2rem;\n}\n\n.metric-card {\n    background: white;\n    border-radius: 12px;\n    padding: 1.5rem;\n    display: flex;\n    align-items: flex-start;\n    gap: 1rem;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n    transition: transform 0.2s, box-shadow 0.2s;\n    cursor: pointer;\n}\n\n.metric-card:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.metric-icon {\n    width: 48px;\n    height: 48px;\n    border-radius: 12px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 1.5rem;\n}\n\n.metric-icon.users {\n    background-color: #e3f2fd;\n    color: #1976d2;\n}\n\n.metric-icon.gmv {\n    background-color: #e8f5e9;\n    color: #2e7d32;\n}\n\n.metric-icon.revenue {\n    background-color: #fce4ec;\n    color: #c2185b;\n}\n\n.metric-icon.active-transactions {\n    background-color: #e8eaf6;\n    color: #3f51b5;\n}\n\n.metric-content {\n    flex: 1;\n}\n\n.metric-content h3 {\n    margin: 0;\n    font-size: 0.9rem;\n    color: #666;\n    margin-bottom: 0.5rem;\n}\n\n.metric-value {\n    font-size: 1.5rem;\n    font-weight: 600;\n    color: #333;\n    margin-bottom: 0.5rem;\n}\n\n.metric-growth {\n    font-size: 0.9rem;\n    display: flex;\n    align-items: center;\n    gap: 0.25rem;\n}\n\n.metric-growth.positive {\n    color: #2e7d32;\n}\n\n.metric-growth.negative {\n    color: #d32f2f;\n}\n\n.metric-label {\n    font-size: 0.9rem;\n    color: #666;\n    display: flex;\n    align-items: center;\n    gap: 0.25rem;\n}\n\n/* Modal Styles */\n.modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.5);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1000;\n}\n\n.modal-content {\n    background: white;\n    border-radius: 12px;\n    padding: 2rem;\n    width: 90%;\n    max-width: 1000px;\n    max-height: 90vh;\n    overflow-y: auto;\n}\n\n.modal-content h2 {\n    margin: 0 0 1.5rem 0;\n    color: #333;\n}\n\n.metrics-controls {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 1.5rem;\n    margin-bottom: 2rem;\n    padding: 1rem;\n    background: #f8f9fa;\n    border-radius: 8px;\n}\n\n.timeframe-selector,\n.date-range {\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n}\n\n.date-range {\n    flex: 1;\n    justify-content: flex-end;\n}\n\n.date-input {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n}\n\n.metrics-controls label {\n    color: #666;\n    font-size: 0.9rem;\n}\n\n.metrics-controls select,\n.metrics-controls input {\n    padding: 0.5rem;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    font-size: 0.9rem;\n}\n\n.chart-container {\n    background: white;\n    padding: 1rem;\n    border-radius: 8px;\n    margin-bottom: 2rem;\n    height: 400px;\n}\n\n.modal-actions {\n    display: flex;\n    justify-content: flex-end;\n    gap: 1rem;\n}\n\n.btn {\n    padding: 0.75rem 1.5rem;\n    border-radius: 6px;\n    border: none;\n    cursor: pointer;\n    font-size: 0.9rem;\n    font-weight: 500;\n    transition: background-color 0.2s;\n}\n\n.btn.primary {\n    background-color: #4a90e2;\n    color: white;\n}\n\n.btn.primary:hover {\n    background-color: #357abd;\n}\n\n/* Add responsive grid for smaller screens */\n@media (max-width: 1200px) {\n    .metrics-grid {\n        grid-template-columns: repeat(2, 1fr);\n    }\n}\n\n@media (max-width: 768px) {\n    .metrics-grid {\n        grid-template-columns: 1fr;\n    }\n\n    .metrics-controls {\n        flex-direction: column;\n        gap: 1rem;\n    }\n\n    .date-range {\n        flex-direction: column;\n        align-items: stretch;\n    }\n\n    .modal-content {\n        width: 95%;\n        padding: 1rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
